import React, {Component} from 'react';
import Table from '../../../../components/Table';
import CongressFormModal from './components/CongressFormModal'
import CongressDetailModal from './components/CongressDetailModal'
import DeleteCongressModal from './components/DeleteCongressModal'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from "lodash";

class Congresses extends Component {
    static contextTypes = {api: PropTypes.object};

    constructor(props){
        super(props);
        this.state = {
            addingCongress:false
        };
        this.loadData = _.debounce(this.loadData, 450);

    }

    loadData = ( tableState )=>{
        this.tableState = tableState;
        const filters = { ...tableState.filters, 'order[id]':'DESC' };
        this.context.api.congresses.get( tableState.page, tableState.pageSize, '@Class.Congresses.congresses.get', filters )
    };

    openAddCongress = ()=> this.setState({addingCongress:true});

    closeAddCongress = ()=> {
        this.loadData(this.tableState);
        this.setState({addingCongress:false});
    };

    onDetailCongress= congress => this.setState( {detailingCongress:congress} );

    closeDetailCongress = ()=> this.setState({detailingCongress:false});

    onEditCongress = e => {
        e.stopPropagation();
        this.setState( {editingCongress: e.currentTarget.dataset.index} )
    };

    closeEditCongress = () => this.setState({editingCongress:false});

    onDeleteCongress = e =>{
        e.stopPropagation();
        this.setState( {deletingCongress: e.currentTarget.dataset.index} )
    };

    deleteCongress =  congress =>{
        this.closeDeleteCongress();
        this.context.api.congresses.delete( congress.id )

    };

    closeDeleteCongress = () => {return this.setState({deletingCongress:false})};

    tableDefinition =
        [
            {
                name:'Acciones',
                accessor: ( data, index )=>
                    <span>
                        <button className='btn btn-xs btn-primary' data-index={index} onClick = {this.onEditCongress}><i className='ti-pencil'/></button>&nbsp;
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteCongress}><i className='ti-trash'/></button>
                    </span>
            }, {
            name:'Nombre',
            id:'name',
            filterable:true,
            accessor:'name',
        }, {
            name:'Año',
            id:'year',
            filterable:true,
            accessor:'year'
        }
        ];

    render(){
        return(
            <div className="container-fluid Directory">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Listado de congresos</h4>
                            </div>
                            <div className="card-content">
                                <div className='buttonContainer'>
                                </div>
                                <div className='buttonContainer'>
                                    <button className='btn btn-success btn-fill btn-magnify pull-right' onClick={this.openAddCongress}>
                                        <span className='btn-label'><i className='ti-plus'/></span>
                                    </button>
                                    <a href={this.context.api.congresses.exportUrl(this.tableState?{...this.tableState.filters}:null, 'xlsx')}>
                                        <button className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar excel</span>
                                        </button>
                                    </a>
                                    <a href={this.context.api.congresses.exportUrl(this.tableState?{...this.tableState.filters}:null, 'pdf')}>
                                        <button className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar PDF</span>
                                        </button>
                                    </a>
                                    <div className='clearfix'/>
                                </div><br/>
                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.congressesMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={ this.tableDefinition }
                                    data={this.props.congresses}
                                    trProps = {(congress)=>({onClick:()=>this.onDetailCongress(congress)})}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                  {/*New congress Modal */}
                {this.state.addingCongress?
                    <CongressFormModal
                        onHide={this.closeAddCongress}
                    /> :null}
                {/*  Edit congress Modal */}
                {this.state.editingCongress?
                    <CongressFormModal
                        onHide={this.closeEditCongress}
                        editing = { this.props.congresses[ this.state.editingCongress ] }
                    /> :null}
                {/* Delete congress Modal*/}
                {this.state.deletingCongress?
                    <DeleteCongressModal
                        congress={ this.props.congresses[ this.state.deletingCongress ]}
                        onHide={this.closeDeleteCongress}
                        onConfirm={this.deleteCongress}
                    /> :null}
                {/* Show congress detail Modal*/}
                {this.state.detailingCongress?
                    <CongressDetailModal
                        congress={ this.state.detailingCongress }
                        onHide={this.closeDetailCongress}
                    />
                    :null}
            </div>
        );
    }
}

const mapStateToProps = ( { api: {congresses=[], congressesMeta={}  } } )=>{
    return {congresses, congressesMeta}
};

export default connect(mapStateToProps)(Congresses);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Congresses/index.jsx